import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  constructor(private http: HttpClient) { }

  getDeptOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/department/getDeptOptions`;
    return this.http.post(url, null);
  }
}
